var ClientsDistributors = $.extend(false, BaseModule ,{
    api_route : 'clients',

    data : {
		module		: 'clients-distributors',
		page		: 1,
		limit		: 40,
		sort_term	: 'id',
		sort_way	: 'DESC',
        view        : 'list',
        hosted_shop : 1,
        with        : 'logo_file',
        details_with: 'logo_file:logo_file_dark:logo_file_light:products:manufacturers:categories:users:languages',
        pagination  : true
	},
	actions:function(action,id){
		"use strict";
        var module = this,module_name = module.data.module;

        switch(action){
            case "edit": case "duplicate":

                                  module.load_entry(id,module_name,action);

                break;
        }
    },
    load_entry: function (id,module,action,overwrites) {
        var m = module.split('-');
        $('.' + module + '-wrapper').hide();
        var url = API + 'clients/'+id;
        
        if(window[ucwords(m)].data.details_with){
            url += '/' + window[ucwords(m)].data.details_with;
        }else if(window[ucwords(m)].data.list_with){
            url += '/' + window[ucwords(m)].data.list_with;
        }else if(window[ucwords(m)].data.with){
            url += '/' + window[ucwords(m)].data.with;
        }

        if(action!='duplicate'){

            window.history.pushState( {} , '', '/clients-distributors/'+id );
        }

        window[ucwords(m)].data['no-cache'] = 1;

        $.ajax({

            url : url,

            data: {
                id          : id,
                intent      : action,
                view		: 'distributors',
                module      : module,
                overwrites  : overwrites
            },
            success: function (data) {

                delete window[ucwords(m)].data['no-cache'];

                $('.page-header').hide();

                $('.list-container[data-target="'+module+'"]').empty();
                $('.' + module + '-filters').hide();

                $('.details-container[data-target="'+module+'"]').html(data.markup).show();

                if(action === 'duplicate'){
                    $('.details-container[data-target="'+module+'"] form input.disabled_hidden_value').remove();
                     $('.details-container[data-target="'+module+'"] form input').removeAttr('disabled');
                     $('.details-container[data-target="'+module+'"] form input[name="id"]').val(0);
                     $('.details-container[data-target="'+module+'"] form input[name="common_id"]').val(0);
                }

                initForm('.details-container[data-target="'+module+'"] form');

                var $title = '';
                if( $('.details-container[data-target="'+module+'"] form input[name="label"]').length > 0){
                    $title = ' / ' +   $('.details-container[data-target="'+module+'"] form input[name="label"]').val();
                }else if( $('.details-container[data-target="'+module+'"] form input[name="title"]').length > 0){
                    $title = ' / ' +   $('.details-container[data-target="'+module+'"] form input[name="title"]').val();
                }else if( $('.details-container[data-target="'+module+'"] form input[name="name"]').length > 0){
                    $title = ' / ' +   $('.details-container[data-target="'+module+'"] form input[name="name"]').val();
                }else if( $('.details-container[data-target="'+module+'"] form input[name="attributes[name]"]').length > 0){
                    $title = ' / ' +  $('.details-container[data-target="'+module+'"] form input[name="attributes[name]"]').val();
                }

                $('h2.page-title small').html($title);

                if(window[ucwords(m)].after_load_entry){
                    window[ucwords(m)].after_load_entry();
                }
            }
        });
    },
	init:function(){}
});

$(document).ready(function(){
	ClientsDistributors.init();
});